import React from "react";
import styles from "../Dashboard.module.css";

const EventManagement = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Event Management</main>
    </div>
  );
};

export default EventManagement;
